export default "__VITE_ASSET__OPZWftboYm6TL9jNDM15Jw__"